(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pages-brand-test"]) return;
  try {
    
jQuery('a:contains("PDF Link 1")').filter(function(index)
{
	//window.alert( $(this).prop("href"))    
	//return $(this).text() === "PDF Link 1";
	jQuery(".pdflink1").prop("href", $(this).prop("href"))
	jQuery(this).css("display","none");
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pages-services"]) return;
  try {
     
  /*if ( jQuery(".services-original img")[0] != undefined ){
    jQuery('.vsbp-main-img').prop("src", jQuery(".services-original img")[0].src);
    jQuery('.vsbp-main-img').css("visibility","visible");
    jQuery(".services-original img")[0].remove();
  }

  var _text = document.querySelectorAll('.services-original p');

  if ( _text != undefined  ){
    var _div_text_html = "";
	Array.prototype.forEach.call(_text, function(element, index) {
      
      var t = element.parentNode.removeChild(element);
      if ( t.innerHTML !== ""){
        _div_text_html += t.outerHTML;
      }
    });
    document.querySelector('.div-column-left-text').innerHTML = _div_text_html;
  }
  document.querySelector('.services-original').innerHTML = "";
  */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pages-virtual-showroom-brand"]) return;
  try {
    
  if ( jQuery(".div-column-left-text img")[0] != undefined ){
     jQuery('.vsbp-main-img').prop("src", jQuery(".div-column-left-text img")[0].src);
     jQuery('.vsbp-main-img').css("visibility","visible");
     jQuery(".div-column-left-text img")[0].remove();
  }
    
  var pdf_btns = document.querySelectorAll('.div-column-left-text a');
  
  if ( pdf_btns != undefined  ){
  var _div_pdf_html = "";
	Array.prototype.forEach.call(pdf_btns, function(element, index) {
      var a = element.parentNode.removeChild(element);
      _div_pdf_html += a.outerHTML
    });
    document.querySelector('.div-column-right-pdf').innerHTML = _div_pdf_html;
  }
  
/*var text = document.querySelectorAll('.virtual-showroom-brand-original p');

  if ( text != undefined  ){
    var _div_text_html = "";
	Array.prototype.forEach.call(text, function(element, index) {
      
      var t = element.parentNode.removeChild(element);
      if ( t.innerHTML !== ""){
        _div_text_html += t.outerHTML;
      }
    });
    document.querySelector('.div-column-left-text').innerHTML = _div_text_html;
  }
  document.querySelector('.virtual-showroom-brand-original').innerHTML = "";
*/
  

  } catch(e) { console.error(e); }
})();
})();
